import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=b4115e70"
import script from "./placeholder.vue?vue&type=script&lang=js"
export * from "./placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4115e70')) {
      api.createRecord('b4115e70', component.options)
    } else {
      api.reload('b4115e70', component.options)
    }
    module.hot.accept("./placeholder.vue?vue&type=template&id=b4115e70", function () {
      api.rerender('b4115e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/placeholder.vue"
export default component.exports